import { render, staticRenderFns } from "./CarbonCostByMethodDetail.vue?vue&type=template&id=5842519b"
import script from "./CarbonCostByMethodDetail.vue?vue&type=script&lang=js"
export * from "./CarbonCostByMethodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports